/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'

const IconFacebook = props => {
  const { className, width = 24, height = 24, onClick, style } = props
  const title = 'icon-facebook'
  const dataTestId = props['data-testid'] || title

  return (
    <svg
      viewBox="64 64 384 384"
      style={style}
      className={className}
      width={width}
      height={height}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <title>{title}</title>
      <g id="Layer_1" />
      <g id="Layer_2">
        <path
          d="M426.8,64H85.2C73.5,64,64,73.5,64,85.2l0,341.6c0,11.7,9.5,21.2,21.2,21.2H256V296h-45.9v-56H256v-41.4
          c0-49.6,34.4-76.6,78.7-76.6c21.2,0,44,1.6,49.3,2.3v51.8l-35.3,0c-24.1,0-28.7,11.4-28.7,28.2V240h57.4l-7.5,56H320v152h106.8
          c11.7,0,21.2-9.5,21.2-21.2V85.2C448,73.5,438.5,64,426.8,64z"
        />
      </g>
    </svg>
  )
}

export default IconFacebook
